import { StyleObject } from 'styletron-standard';

export const ELLIPSIS: StyleObject = {
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
};
